import './Toaster.scss';
import React from 'react';
import PropTypes from 'prop-types';

class SuccessToaster extends React.Component {
  static propTypes = {
    onDismiss: PropTypes.func,
    text: PropTypes.string.isRequired,
  }

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  render() {
    const { getString } = this.context;
    return (
      <div className="toaster-wrapper">
        <div className="toaster-background" />
        <div className="toaster">
          <div className="toaster-content">
            <div className="toaster-icon">
              <span className="glyphicon glyphicon-ok" aria-hidden="true" />
            </div>
            <span className="toaster-text">{this.props.text}</span>
          </div>
          <div className="toaster-action">
            <a className="btn btn-link ok-btn" onClick={this.props.onDismiss}>
              <span>{getString('AA_OK')}</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default SuccessToaster;
